"use strict";
/**
 * User Management Services Export
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.userManagementService = exports.UserManagementService = void 0;
var userManagementService_1 = require("./userManagementService");
Object.defineProperty(exports, "UserManagementService", { enumerable: true, get: function () { return userManagementService_1.UserManagementService; } });
Object.defineProperty(exports, "userManagementService", { enumerable: true, get: function () { return userManagementService_1.userManagementService; } });
//# sourceMappingURL=index.js.map